import { cn } from '@/lib/utils';
import { AlertTriangle, ArrowUp, Minus, ArrowDown } from 'lucide-react';
import { PRIORIDADE_LABELS, PRIORIDADE_COLORS, type PrioridadeSolicitacao } from '@/types/solicitacao';

interface SolicitacaoPrioridadeBadgeProps {
  prioridade: PrioridadeSolicitacao;
  showIcon?: boolean;
  className?: string;
}

const PRIORIDADE_ICONS: Record<PrioridadeSolicitacao, React.ReactNode> = {
  critica: <AlertTriangle className="h-3 w-3" />,
  alta: <ArrowUp className="h-3 w-3" />,
  media: <Minus className="h-3 w-3" />,
  baixa: <ArrowDown className="h-3 w-3" />,
};

export function SolicitacaoPrioridadeBadge({ 
  prioridade, 
  showIcon = true, 
  className 
}: SolicitacaoPrioridadeBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium',
        PRIORIDADE_COLORS[prioridade],
        className
      )}
    >
      {showIcon && PRIORIDADE_ICONS[prioridade]}
      {PRIORIDADE_LABELS[prioridade]}
    </span>
  );
}
